"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const MultiSelectWrapper = styled_components_1.default.div ``;
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const MultiSelect = (props) => {
    const { fieldData, onChange } = props;
    const [options, setOptions] = (0, react_1.useState)([]);
    const [fallbackOptions, setFallbackOptions] = (0, react_1.useState)([]);
    const [showDetailFormat, setShowDetailFormat] = (0, react_1.useState)(false);
    const { type, disabled } = fieldData;
    const handleSelect = activatedIndex => {
        const selectedOption = options[activatedIndex];
        selectedOption.selected = !selectedOption.selected;
        onChange(Object.assign(fieldData, { options }));
    };
    const renderMultiSelect = () => options.map((option, index) => (react_1.default.createElement("div", { key: (0, react_uid_1.uid)(option) },
        react_1.default.createElement(material_1.ListItem, { secondaryAction: react_1.default.createElement(material_1.Checkbox, { edge: "end", onChange: () => handleSelect(index), checked: option.selected, inputProps: { 'aria-labelledby': option.label } }), disablePadding: true },
            react_1.default.createElement(material_1.ListItemButton, { onClick: () => handleSelect(index) },
                react_1.default.createElement(material_1.ListItemText, { id: option.label, primary: option.label }))),
        react_1.default.createElement(material_1.Divider, null))));
    const renderSelectedOptions = () => {
        const selectedOptions = fieldData.options.filter(option => option.selected);
        if (selectedOptions.length < 1) {
            return react_1.default.createElement("span", null, fieldData.placeholder ? fieldData.placeholder : i18n_js_1.default.t('no_recurrence'));
        }
        return selectedOptions.reduce((acc, curr, index) => {
            if (index === 0) {
                return `${curr.label}`;
            }
            return `${acc}, ${curr.label}`;
        }, '');
    };
    const openDetailFormat = () => {
        setFallbackOptions(JSON.parse(JSON.stringify(fieldData.options)));
        setShowDetailFormat(true);
    };
    const handleDialogButtonClick = (action = '') => {
        if (action === 'dismiss') {
            setOptions(fallbackOptions);
            onChange(Object.assign(fieldData, { options: fallbackOptions }));
        }
        setShowDetailFormat(false);
    };
    (0, react_1.useEffect)(() => {
        setOptions(JSON.parse(JSON.stringify(props.fieldData.options)));
    }, [props.fieldData.options]);
    return (react_1.default.createElement(MultiSelectWrapper, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
        type === 'multi_select_inline' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, fieldData.label),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, options.length > 0 && react_1.default.createElement(material_1.List, null, renderMultiSelect())))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.List, null,
                    react_1.default.createElement(material_1.ListItem, { onClick: openDetailFormat, disablePadding: true },
                        react_1.default.createElement(material_1.ListItemButton, null,
                            react_1.default.createElement(material_1.ListItemText, { primary: fieldData.label, secondary: renderSelectedOptions() }))))),
            react_1.default.createElement(material_1.Dialog, { open: showDetailFormat, TransitionComponent: Transition, keepMounted: true, onClose: handleDialogButtonClick, "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, fieldData.label),
                react_1.default.createElement(material_1.DialogContent, null,
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, options.length > 0 && react_1.default.createElement(material_1.List, { sx: { minWidth: 200 } }, renderMultiSelect()))),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleDialogButtonClick('dismiss');
                        } }, i18n_js_1.default.t('cancel')),
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleDialogButtonClick();
                        } }, "Ok"))))),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(FieldValidationError, null, fieldData.errors ? fieldData.errors.map(error => react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error)) : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = MultiSelect;
